/**
 * Created by lycheng on 2019/7/9.
 */

import './index.scss'

function bindEvent () {
  $('.scope-tabs').on('click', '.tab-title-box > li', function () {
    let $this = $(this)
    let $tabTitleBox = $this.parent()
    let $tabConBox = $($tabTitleBox.data('for'))
    if (!$tabConBox.length) {
      $tabConBox = $tabTitleBox.closest('.scope-tabs').children('.tab-con-box')
    }
    let index = $this.index()
    let $sibling = $this.siblings('.active')
    $sibling.removeClass('active')
    $tabConBox.children('.active').removeClass('active')
    $this.addClass('active')
    $tabConBox.children().eq(index).addClass('active')
  })
}
bindEvent()



// WEBPACK FOOTER //
// ./src/js/libs/utils-tab/index.js